import Keycloak from 'keycloak-js';

// import AuthorizationFetcher from 'src/js/authorization/authorization_fetcher';
import {constants, StateId, utils} from 'src/js/common';
// import {getConfig} from 'src/js/containers/config/config_actions';
import {cleanLocalStorage} from 'src/js/hooks';

import * as at from './login_action_types';

const logger = utils.LogUtils.getLogger('LoginActions', constants.LIBRARY_NAME);

export function logout(stateId: StateId, logoutUrl, keycloak: Keycloak) {
  return (dispatch) => {
    cleanLocalStorage('/');
    dispatch({type: at.LOGOUT, stateId});
    const redirectTo = new URL(window.location.href);
    redirectTo.search = '';
    return keycloak.logout({
      redirectUri: redirectTo.href,
    });
  };
}

export function resetIdleTime(stateId, value) {
  return (dispatch) => {
    dispatch({type: at.RESET_IDLE_TIME, payload: value, stateId});
  };
}
